import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { SidenavService } from '@services/sidenav.service';
import { SidebarItem } from '@shared/sidebaritem';
import { sidebarItems } from './menu';

@Component({
	selector: 'app-sales',
	templateUrl: './sales.component.html',
	styleUrls: ['./sales.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class SalesComponent implements OnInit {
	sidebarItems: SidebarItem[] = sidebarItems;

	constructor(private sidenavService: SidenavService) {}

	ngOnInit(): void {
		this.sidenavService.setMenuData(this.sidebarItems);
		void this.sidenavService.closeRightPanel();
	}
}
